import { service } from '@/request/index'

export const ApiModifierUpdate: any = params => service.post('rms/merchant/menu/modifier/update', params);
